<template>
  <div>
    <template v-if="!hasToken">
      <va-alert type="warning">
        <p class="th-alert-body">Jika email terdaftar disistem, kami akan mengirimkan email untuk reset kata sandi.</p>
      </va-alert>
      <hr style="margin: 25px 0" />
      <va-form ref="form" type="vertical" class="th-form">
        <va-form-item label="Email" style="margin-bottom: 30px;">
          <va-input name="Email" v-model="forgotInput.email" />
        </va-form-item>
        <button type="submit" class="va-btn va-btn-block va-btn-md va-btn-primary" @click.prevent="sendForgotPasswordRequest">
          <div>Kirim Link Menuju Email</div>
        </button>
      </va-form>
    </template>
    <template v-else>
      <va-form ref="form" type="vertical" class="th-form">
        <va-form-item label="Kata Sandi Baru">
          <va-input name="Kata Sandi Baru" type="password" v-model="forgotInput.newPassword" />
        </va-form-item>
        <va-form-item label="Konfirmasi Kata Sandi Baru" style="margin-bottom: 30px;">
          <va-input name="Konfirmasi Kata Sandi Baru" type="password" v-model="forgotInput.retypeNewPassword" />
        </va-form-item>
        <button type="submit" class="va-btn va-btn-block va-btn-md va-btn-primary" @click.prevent="handleResetPassword">
          <div>Reset Sekarang</div>
        </button>
      </va-form>
    </template>
    <div style="margin-top: 30px;" class="text-center">
      <span class="th-link small th-hover-pointer" @click.prevent="goTo('Masuk')">Kembali ke Login</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hasToken: false,
      token: null,
      forgotInput: {
        email: null,
        newPassword: null,
        retypeNewPassword: null,
      },
    }
  },
  // watch: {
  //   '$route'(to, from) {
  //     if (to.query) this.hasToken = true
  //   },
  // },
  mounted() {
    this.token = this.$route.query.token
    if (this.$route.query.token) this.hasToken = true
  },
  methods: {
    // demoAkun() {
    //   console.log('masuk')
    // },
    goTo(routeName) {
      if (routeName === this.$route.name) return
      this.$router.push({ name: routeName })
    },
    // changeHasToken() {
    //   this.hasToken = !this.hasToken
    // },
    sendForgotPasswordRequest() {
      this.$store.dispatch('user/GENERATE_LINK_FORGOT_PASSWORD', { email: this.forgotInput.email })
        .then(res => {
          console.log(res)
          if (res.status) {
            this.notification.success({
              title: 'Sukses',
              message: 'Berhasil Mengirim Permintaan Lupa Sandi, Silahkan Cek Inbox Email Anda.',
              duration: 3000,
            })
          } else {
            this.notification.error({
              title: 'Error',
              message: 'Gagal Memperbaharui Akun User',
              duration: 3000,
            })
          }
        })
        .catch(err => {
          console.log('handleAccountChange err =>', err)
          this.notification.error({
            title: 'Error',
            message: err,
            duration: 3000,
          })
        })
    },
    handleResetPassword() {
      if (this.forgotInput.newPassword === null || this.forgotInput.retypeNewPassword === null) {
        console.log('Password still empty!')
        this.notification.error({
          title: 'Error',
          message: 'Sandi Baru dan Konfirmasi Masih Ada Yang Kosong!',
          duration: 3000,
        })
      } else if (this.forgotInput.newPassword === this.forgotInput.retypeNewPassword) {
        this.$store.dispatch('user/RESET_FORGOTTEN_PASSWORD', { token: this.token, password: this.forgotInput.newPassword })
          .then(res => {
            console.log(res)
            if (res.status) {
              this.notification.success({
                title: 'Sukses',
                message: 'Berhasil Merubah Password, Silahkan Login Kembali',
                duration: 3000,
              })
            } else {
              this.notification.error({
                title: 'Error',
                message: 'Gagal Merubah Password',
                duration: 3000,
              })
            }
          })
          .catch(err => {
            console.log('handleResetPassword err =>', err)
            this.notification.error({
              title: 'Error',
              message: err,
              duration: 3000,
            })
          })
      } else {
        console.log('Password does not match!')
        this.notification.error({
          title: 'Error',
          message: 'Sandi Baru dan Konfirmasi Tidak Sama!',
          duration: 3000,
        })
      }
    },
  },
}
</script>

<style>

</style>
